// _browse-door.js — the EAGER half of the browse verb pair (ASK-154 seam 2): which seat carries a verb, and which
// object a live hover resolves to. Everything that moves is lazy (`_browse-verbs.js`); this is the part the stage
// needs before the first press, kept tiny and pure so it costs the customer bundle almost nothing and unit-tests
// headlessly (`scripts/test-browse-verbs.mjs`).

/**
 * Does this seat play the verb pair? It does when its slot carries the socket's derived verb (`slot.browse`, an r55
 * boot) and the fixture is not a LIDDED box: the box family pages its stock through the lid lifecycle — the shipped
 * longbox riffle, untouched by this seam — so its seats keep `in-box`. Absent stamp (r54) → false: today's path.
 */
export function isVerbSeat({ slot, browseVerbs }) {
	return browseVerbs !== false && !!slot?.browse?.pair;
}

/**
 * A lidless holder's stock that the composer seated `in-box` (the wall rack, the bank, the spinners, the case — the
 * default when nothing else claims the fixture) is wired to the SEATED grain when it carries a verb: on a holder with
 * no lid there is no box lifecycle to page it through, so before the pair it was scenery. With the verb it becomes a
 * thing the customer pulls out and picks up — research §4's "every fixture becomes browsable at once".
 */
export function seatedGrainForVerb({ interaction, verbSeat }) {
	return verbSeat && interaction === "in-box";
}

/**
 * The object carrying a verb stamp for one interactable kind's active state — whatever shape the kind keeps it in
 * (a mesh, `{ mesh }`, `{ root }`, a bin's `{ sleeves, browseIdx }`), walked UP to the stamped root, because the ray
 * hits a grandchild of a multi-mesh product.
 */
export function browseTargetOf(active) {
	if (!active) return null;
	const bin = Array.isArray(active.sleeves) ? active.sleeves[Math.max(0, active.browseIdx ?? 0)]?.mesh : null;
	for (const c of [active, active.mesh, active.root, bin]) {
		for (let n = c; n && n.isObject3D; n = n.parent) if (n.userData?.browse?.pair) return n;
	}
	return null;
}
